import { Link } from 'react-router-dom';
import { CalendarPlusIcon } from 'lucide-react';
import { ScaledDesign } from '../marketing/ScaledDesign';
import { templateByKey } from '../marketing/marketingOptions';
import { unplannedDesigns } from '../marketing/designPlanning';
import type { MarketingDesign } from '../../core/types/marketing';
import type { SocialPost } from '../../core/types/social';
type Props = {
  designs: MarketingDesign[];
  posts: SocialPost[];
  onPlan: (design: MarketingDesign) => void;
};

/** Zoveel tonen we; de rest staat bij Ontwerpen. */
const MAX = 6;

/**
 * Ontwerpen voor Instagram die nog nergens in de planning staan. Eén tik zet ze op de eerste vrije
 * dag, met tekst en hashtags uit het ontwerp. Zo hoeft Sarah niet tussen twee schermen te pendelen.
 */
export function ReadyDesigns({
  designs,
  posts,
  onPlan
}: Props) {
  const ready = unplannedDesigns(designs, posts);
  if (ready.length === 0) return null;
  const shown = ready.slice(0, MAX);
  return <section aria-labelledby="ready-designs" className="mt-8" data-id="element-4633" data-mp="mgkolo6zxooo">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-2" data-id="element-4634" data-mp="1luinkszyvldp">
        <h2 id="ready-designs" className="text-[15px] font-medium text-ink" data-id="element-4635" data-mp="1gvfi57g2rd57">
          Klaar om in te plannen
        </h2>
        <Link to="/be/ontwerpen" className="text-[13px] text-muted underline-offset-4 hover:text-ink hover:underline" data-id="element-4636" data-mp="1vl4vs25ct9md">
          {ready.length > MAX ? `Alle ${ready.length} ontwerpen` : 'Naar ontwerpen'}
        </Link>
      </div>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-6" data-id="element-4637" data-mp="24m30ynrj3n6j">
        {shown.map(d => {
        const t = templateByKey(d.template);
        return <li key={d.id} className="flex flex-col" data-id="element-4638" data-mp="2ehms6wv5dxoy">
              <Link to={`/be/ontwerpen/${d.id}`} role="img" aria-label={`Voorbeeld van ${d.name || 'naamloos ontwerp'}`} className="block aspect-[4/5] rounded-lg bg-white/70 p-2.5 ring-1 ring-line transition-colors duration-150 ease-soft hover:bg-white" data-id="element-4639" data-mp="29j1vh7f3tw59">
                <ScaledDesign design={d} fill data-id="element-4640" data-mp="2f9e8kmktw0lr" />
              </Link>
              <p className="mt-2 truncate text-[13px] text-ink" data-id="element-4641" data-mp="2k5uzfojewt2j">{d.name || 'Naamloos ontwerp'}</p>
              <p className="truncate text-[12px] text-muted" data-id="element-4642" data-mp="2o7yiozcbp1yd">{t.name}</p>
              <button type="button" onClick={() => onPlan(d)} className="mt-2 inline-flex min-h-[36px] items-center justify-center gap-1.5 rounded-full border border-line bg-white px-3 text-[13px] text-ink transition-colors duration-150 ease-soft hover:border-ink/40" data-id="element-4643" data-mp="2t72ulxqmtdse">
                <CalendarPlusIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-4644" data-mp="37xa3blqu7ifw" />
                Inplannen
                <span className="sr-only" data-id="element-4645" data-mp="3bx1149es6ytx">: {d.name || 'naamloos ontwerp'}</span>
              </button>
            </li>;
      })}
      </ul>
    </section>;
}